var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Collapse from 'bootstrap/js/dist/collapse';
import { CarouselComponent } from '../../twig/components/Carousel';
export class Collapse extends Component {
    constructor(isDebugEnabled = false) {
        super('Collapse', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.collapse').each((collapse) => {
                new BS_Collapse(collapse.get(0), { toggle: false });
                collapse.on('shown.bs.collapse', (event) => {
                    CarouselComponent.resizeControls();
                    CarouselComponent.resizeCaptions();
                });
            });
            this.success();
        });
    }
}
